import React, {useState} from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import { Accordion, IItem as IIccordionItem } from '~common/accordion'
import { useIsMobile } from "~helpers/hooks/useIsMobile";
import { AmplitudeCounter } from "~/amplitude-counter";

const ImproveServiceScreen = () => {
  const isMobile = useIsMobile();
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const questions: IIccordionItem[] = [
    {
      title: 'Клиенты звонят в нерабочее время?',
      text: 'Настройте голосовое приветствие. Вместо сброса звонка клиент услышит записанное аудиосообщение и поймет, что делать дальше.'
    },
    {
      title: 'Не справляетесь с потоком входящих?',
      text: 'Настройте голосовое меню. Каждое нажатие в тоновом наборе ведет клиента к цели без участия оператора.'
    },
    {
      title: 'Клиенты долго ждут на линии?',
      text: 'Настройте маршрут звонка. Маршрутизация звонка убирает лишние переводы между коллегами, сокращает время на обработку звонка и клиент попадает к менеджеру быстрее.'
    }
  ]

  const iconsDictionary = [
    <img src={process.env.PUBLIC_DIR + '/images/index_page/improve_service/icon_1.svg'} />,
    <img src={process.env.PUBLIC_DIR + '/images/index_page/improve_service/icon_2.svg'} />,
    <img src={process.env.PUBLIC_DIR + '/images/index_page/improve_service/icon_3.svg'} />,
  ]
  const colorsDictionary = ['rgb(179, 238, 226)', '#d4d3ff', '#cfeff8']

  return (
    <Screen
      title={!isMobile && <span>Улучшите свой <StyledScreen.GreenText>сервис</StyledScreen.GreenText> с onlinepbx</span> || null}
    >
      <Styled.Container>
        <Styled.Left>
          <Accordion
            data={questions}
            initialElemIndex={0}
            onChange={(index: number, item: IIccordionItem) => {
              setActiveItemIndex(index)
              AmplitudeCounter('click_open_question', { question: item.title })
            }}
          />
        </Styled.Left>
        <Styled.Right>
          <Styled.IconWrapp>
            <Styled.IconBg color={colorsDictionary[activeItemIndex]}>
              <Styled.IconPlace>
                {iconsDictionary[activeItemIndex]}
              </Styled.IconPlace>
            </Styled.IconBg>
          </Styled.IconWrapp>
        </Styled.Right>
      </Styled.Container>
    </Screen>
  )
}

export { ImproveServiceScreen }